<div class="container-fluid" style="margin-bottom: 50px;">
    <div class="container pt-4">
      <div style="font-size: 22px !important;
          font-weight: 400;cursor: pointer;">
        <span>
          <i class="fa fa-address-card" style="color:#800000"></i>&nbsp;&nbsp;Managing Partner Dashboard
        </span>
      </div>
      <!-- <div class="row pt-2"> -->
        <!-- <div class="col-md-2 ">
          <div class="card">
            <div class="row" style="margin-top: 12px;">
            </div>  
            <div class="row">
              <div class="col-md-1"><i class="fa fa-bullhorn" style="color:#f29811"></i></div>
              <div class="col-md-9 cardHeader" style=" color: #800000; " >&nbsp;
                Notification Unread
              </div>
            </div>
            <div class="row" routerLink="/dashboard/manage-announcement">
              <div class="col-md-12" style="text-align: center;">
                <span class="card-content" style="color:#f29811">{{leaveBalanceCount}}</span>
              </div>
            </div>
           </div>
        </div>

        <div class="col-md-6" *ngIf=" userRole=='Partner'" >
          
          <div class="card">
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="" style="text-align: center">
                    <div class="row col-md-12 m-0 p-0" >
                      <div class="col-md-6 right-border" style=" background-color: white; color: #800000; ">
                       Pending Diaries Self
                      </div>
                      <div class="col-md-6 right-border" style=" background-color: white; color: #800000; ">
                        Pending Diaries Team
                      </div>
                      <div class="row col-md-12 m-0 p-0 border">
                        <div class="col-md-3 right-border" style=" background-color: #800000; color: whitesmoke;">
                          To fill
                        </div>
                        <div class="col-md-3 right-border" style=" background-color: #800000; color: white;" >
                          To Approve
                        </div>
                        <div class="col-md-3 right-border" style=" background-color: #800000; color: white;">
                          To fill
                        </div>
                        <div class="col-md-3 right-border" style=" background-color: #800000; color: white;">
                          To Approve
                        </div>
                      </div>
                    </div>

                    <div class="row col-md-12 m-0 p-0 border">
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color: #800000;">
                          {{ pendingDiariesWeekCount || 0 }}
                        </span>   
                      </div>
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color: #800000;">
                        {{  pendingDiaryApproval || 0 }}
                        </span>
                      </div>
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color: #800000;">
                        {{ pendingDiariesWeekTeam || 0 }}
                        </span>
                      </div>
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color: #800000;">
                        {{ pendingDiaryApprovalTeam || 0 }}
                        </span>
                      </div>
                    </div>
                    
              </div>
            </div>
          </div>
        </div>
  
       
  
        <div class="col-md-4"  *ngIf=" userRole=='Partner'">  
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0"  >
              <div class="col-md-1"><i class="fa fa-book" style="color:green"></i></div>
                <div class="col-md-9 cardHeader" style="background-color: white; color: #800000;">&nbsp;
                  Pending Travel Claim
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-6 right-border" style=" background-color: #800000; color: white;">
                  My Claim
                </div>
                <div class="col-md-6 right-border" style=" background-color: #800000; color: white;">
                  To Approve
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-6 right-border" routerLink="/dashboard/travel-sheet">
                <span class="card-content" style="color:#800000">{{unapprovedTsheetAmount| number: '2.'}}</span>
              </div>
              <div class="col-md-6 right-border">
                <span class="card-content" style="color:#800000">{{pendingTsheetApproval| number: '2.'}}</span>
              </div>
            </div> 
          </div>  
         
        </div> -->
        
  
  
  
        <!-- display to everyone excluding manager partner -->
        <!-- <div class="col-md-3" *ngIf="userRole!='Partner'">
          <div class="card cardStyle1">
            <div class="card-body align-items-start">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-book" style="color:#17a2b8"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Pending Diaries
                </div>
              </div>
  
              <div class="row mt-3" routerLink="/dashboard/my-pending-submission">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  To Fill &nbsp;<span class="card-content" style="color:#17a2b8">{{pendingDiariesWeekCount}}</span>&nbsp;Weeks
                </div>
                <div class="col-md-1"></div>
              </div>
  
              <div class="row mt-3" [routerLink]="checkApproverforRoute?['/dashboard/my-pending-approval']:[]">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  To Approve &nbsp;<span class="card-content" style="color:#17a2b8">{{pendingDiaryApproval}}</span>
                </div>
                <div class="col-md-1"></div>
              </div>
  
            </div>
          </div>
        </div>
  
        <div class="col-md-3" *ngIf="userRole!='Partner'">
          <div class="card cardStyle1" style="cursor: pointer;">
            <div class="card-body align-items-start">
  
              <div class="row">
                <div class="col-md-1"><i class="fa fa-book" style="color:#17a2b8"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Pending Travel Claim
                </div>
              </div>
  
              <div class="row mt-3" routerLink="/dashboard/travel-sheet">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                Claim Rs.&nbsp;<span class="card-content" style="color:#17a2b8">{{unapprovedTsheetAmount| number: '2.'}}</span>
                </div>
                <div class="col-md-1"></div>
              </div>
  
              <div class="row mt-3"  [routerLink]="checkApproverforRoute?['/dashboard/my-pending-travel-sheet-approvals']:[]">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                Approve Claim Rs. &nbsp;<span class="card-content" style="color:#17a2b8">{{pendingTsheetApproval| number: '2.'}}</span>
                </div>
                <div class="col-md-1"></div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="col-md-4" *ngIf="userRole!='Partner'">
          <div class="card">
            <div class="card-body align-items-start">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-ban" style="color:#f21118"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                  Penalty As On Today
                </div>
              </div>
  
              <div class="row mt-3" routerLink="/dashboard/my-penalty-summary">
                <div class="col-md-1"></div>
                <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                  <span >Penalty Charged </span><br><span class="card-content" style="color:#800000">{{penaltyCharged}}</span>
                </div>
                </div>
                <div class="row mt-3" routerLink="/dashboard/my-penalty-summary">
                  <div class="col-md-1"></div>
                  <div class="col-md-9" style="text-align: center;background-color: #f2f2f2;">
                    <span >Penalty Uncharged </span><br><span class="card-content" style="color:#800000">{{penaltyUncharged}}</span>
                  </div>
                  </div>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
  
      <!-- display to partners only excluding manager partner -->
      <!-- <div class="row pt-2">
        <div class="col-md-5" *ngIf=" userRole=='Partner'" >
          
          <div class="card">
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div class="" style="text-align: center">
                    <div class="row col-md-12 m-0 p-0" style="  background-color: #800000; color: white; ">
                      <div class="col-md-6 right-border" style=" background-color: white; color: #800000; ">
                      Penalty Self
                      </div>
                      <div class="col-md-6 right-border" style=" background-color: white; color: #800000; ">
                      Penalty Team
                      </div>
                      <div class="row col-md-12 m-0 p-0 border">
                        <div class="col-md-3 right-border">
                          Charged
                        </div>
                        <div class="col-md-3 right-border" >
                          Current
                        </div>
                        <div class="col-md-3 right-border">
                          Charged
                        </div>
                        <div class="col-md-3 right-border" >
                          Current
                        </div>
                      </div>
                    </div>

                    <div class="row col-md-12 m-0 p-0 border">
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color:#800000">
                          {{ penaltyCharged || 0 }}
                        </span>
                      </div>
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color:#800000">
                          {{ penaltyUncharged || 0 }}
                        </span>
                      </div>
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color:#800000">
                          {{ penaltyChargedTeam || 0 }}
                        </span>
                      </div>
                      <div class="col-md-3 right-border">
                        <span class="card-content" style="color:#800000">
                        {{ penaltyUnchargedTeam || 0 }}
                        </span>
                      </div>
                    </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4" *ngIf=" userRole=='Partner'" >
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0">
              <div class="col-md-1"><i class="fa fa-user-times" style="color:#17a2b8"></i></div>
                <div class="col-md-9 cardHeader" style=" background-color: white; color: #800000; ">&nbsp;
                  Leave Current Year
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                  Taken
                </div>
                <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                  Balance
                </div>
                <div class="col-md-4 right-border" style=" background-color: #800000; color: white;">
                  To Approve
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ partnersDashboardLeave.taken || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ partnersDashboardLeave.balance || 0 }}
                </span>
              </div>
              <div class="col-md-4">
                <span class="card-content" style="color:#800000">
                  {{ partnersDashboardLeave.toApprove || 0 }}
                </span>
              </div>
            </div> 
          </div>  
         
        </div>
        <div class="col-md-3" *ngIf="userRole=='Partner'" >
         
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0" >
              <div class="col-md-1"><i class="fa fa-money" style="color:darkviolet"></i></div>
                <div class="col-md-9 cardHeader" style=" background-color: white; color: #800000; ">&nbsp;
                  Overtime Paid
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-6 right-border" style=" background-color: #800000; color: white;">
                  2023-24
                </div>
                <div class="col-md-6 right-border" style=" background-color: #800000; color: white;">
                  2022-23
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-6">
                <span class="card-content" style="color:#800000">
                  {{ overtimePaid || 0 }}
                </span>
              </div>
              <div class="col-md-6">
                <span class="card-content" style="color:#800000">
                  {{ overtimePaidPy || 0 }} 
                </span>
              </div>
            </div> 
          </div> 
        </div>
      </div>   -->
  
      <!-- <div class="row pt-1" *ngIf="(!showDashboard) && (checkHRRole || checkPartnerRole)">
  
  
        <div class="col-md-6">
          <div class="row pt-1">
            <div class="col-md-12">
              <div class="card cardStyle1">
                <div class="card-body align-items-start ml-4 mr-4">
                  <div class="row pb-2" style="text-align: center;">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 cardHeader">
                      <div class="row pb-2">
                        <div class="col-md-1"></div>
                        <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                        <div class="col-md-9 cardHeader">&nbsp;
                          Head count Firm
                        </div>
                        <div class="col-md-1"></div>
                      </div>
                    </div>
                    <div class="col-md-4 cardHeader">
                      <div class="row pb-2">
                        <div class="col-md-1"></div>
                        <div class="col-md-1"><i class="fa fa-header" style="color:orange"></i></div>
                        <div class="col-md-9 cardHeader">&nbsp;
                          Head count Pune
                        </div>
                        <div class="col-md-1"></div>
                      </div>
                    </div>
                  </div>
  
                  <div class="row" style="text-align: center;background-color: #f2f2f2;">
                    <div class="col-md-4 cardHeader">Employees</div>
                  
                    <div class="col-md-4">
                      <span class="card-content" style="color: green;">
                        {{ employeeFirmCount || 0}}
                      </span>
                    </div>
                    <div class="col-md-4">
                      <span class="card-content" style="color: green;">
                        {{ employeePuneCount || 0 }}
                      </span>
                    </div>
                  </div>
  
                  <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
                    <div class="col-md-4 cardHeader">Articles</div>
                   
                    <div class="col-md-4">
                      <span class="card-content" style="color: green;">
                        {{ articleFirmCount || 0 }}
                      </span>
                    </div>
                    <div class="col-md-4">
                      <span class="card-content" style="color: green;">
                        {{ articlePuneCount || 0 }}
                      </span>
                    </div>
  
                  </div>
  
                  <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
                    <div class="col-md-4 cardHeader">Consultants</div>
                    
                    <div class="col-md-4">
                      <span class="card-content" style="color: green;">
                        {{ consultantFirmCount || 0 }}
                      </span>
                    </div>
                    <div class="col-md-4">
                      <span class="card-content" style="color: green;">
                        {{ consultantPuneCount || 0 }}
                      </span>
                    </div>
  
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="row pt-1">
           
          </div>
        </div>
  
    <div class="col-md-6">
      <div class="row pt-1">  
        <div class="col-md-12">
          <div class="card cardStyle1">
            <div class="card-body align-items-start ml-4 mr-4">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-3"></div>
                <div class="col-md-4 cardHeader">
                  <div class="row pb-2">
                    <div class="col-md-1"></div>
                    <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                    <div class="col-md-9 cardHeader">&nbsp;
                      Assets Count Firm
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div>
                <div class="col-md-5 cardHeader">
                  <div class="row pb-2">
                    <div class="col-md-1"></div>
                    <div class="col-md-1"><i class="fa fa-laptop" style="color:blue"></i></div>
                    <div class="col-md-9 cardHeader">&nbsp;&nbsp;
                      Assets Count {{branchName}}
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div>
              </div>
  
              <div class="row" style="text-align: center;background-color: #f2f2f2;">
                <div class="col-md-4 cardHeader">Laptops</div>
               
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ laptopAssetFirmCount || 0}}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ laptopAssetPuneCount || 0 }}
                  </span>
                </div>
              </div>
  
              <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
                <div class="col-md-4 cardHeader">Assigned</div>
                
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ assignedAssetFirmCount || 0 }}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ assignedAssetPuneCount || 0 }}
                  </span>
                </div>
  
              </div>
  
              <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
                <div class="col-md-4 cardHeader">Admin</div>
                
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ instockAssetFirmCount || 0 }}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ instockAssetPuneCount || 0 }}
                  </span>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>    
  
       
      </div> -->

  
      <!-- <div class="pt-3" *ngIf="HrRoleActive" >
        <div class="row">
          
  
  
          <div class="col-md-6">
            <div class="card cardStyle1">
              <div class="card-body align-items-start">
                <div class="row pb-2">
                  <div class="col-md-4"></div>
                  <div class="col-md-1"><i class="fa fa-bell" style="color:violet"></i></div>
                  <div class="col-md-5 cardHeader">&nbsp;
                    Reminders
                  </div>
                  <div class="col-md-3"></div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;">
                    <span>Probation </span>&nbsp;&nbsp;<span class="card-content"
                      style="color: violet;">{{probationCount}}</span>
                  </div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;">
                    <span>Articleship end </span>&nbsp;&nbsp;<span class="card-content"
                      style="color: violet;">{{articleshipEndCount}}</span>
                  </div>
                </div>
  
                <div class="row pb-3">
                  <div class="col-md-1"></div>
                  <div class="col-md-10" style="text-align: center;background-color: #f2f2f2;">
                    <span>Consultants end </span>&nbsp;&nbsp;<span class="card-content"
                      style="color: violet;">{{consultantEndCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
            
          <div class="col-md-2">
            <div class="card cardStyle">
              <div class="card-body align-items-start">
                <div class="row">
                  <div class="col-md-1"><i class="fa fa-hourglass-end" style="color:indigo"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Article vaccancy
                  </div>
                </div>
  
                <div class="row mt-2" routerLink="/dashboard/article-vacancy">
                  <div class="col-md-12" style="text-align: center; margin-top: 25px;">
                    <span class="card-content" style="color:indigo">{{articleVaccancyCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card cardStyle">
              <div class="card-body align-items-start">
                <div class="row">
                  <div class="col-md-1"><i class="fa fa-user-times" style="color:maroon"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Incomplete profile
                  </div>
                </div>
  
                <div class="row mt-2">
                  <div class="col-md-12" style="text-align: center;  margin-top: 25px;">
                    <span class="card-content" style="color:maroon;">{{incompleteProfileCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="card cardStyle1">
              <div class="card-body align-items-start">
                <div class="row">
                  <div class="col-md-1"><i class="fa fa-user-times" style="color:#17a2b8"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Balance leave
                  </div>
                </div>
    
                <div class="row mt-3" routerLink="/dashboard/my-leaves">
                  <div class="col-md-12" style="text-align: center;  margin-top: 25px;">
                    <span class="card-content" style="color:#17a2b8">{{leaveBalanceCount}}</span>&nbsp;
                    <span>Days</span>
                  </div>
                </div>
    
              </div>
            </div>
          </div>
    
          <div class="col-md-2" *ngIf="checkPartnerRole">
            <div class="card cardStyle1">
              <div class="card-body align-items-start">
                <div class="row">
                  <div class="col-md-1"><i class="fa fa-money" style="color:darkviolet"></i></div>
                  <div class="col-md-9 cardHeader">&nbsp;
                    Overtime Paid
                  </div>
                </div>
    
                <div class="row mt-2">
                  <div class="col-md-12" style="text-align: center;  margin-top: 25px;">
                    <span class="card-content" style="color:darkviolet">{{overtimePaid| number: '2.'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
  
        <div class="pt-2">
          <div class="row">
           
  
  
  
          </div>
        </div>
      </div> -->
  
        
      <!-- <div class="row">
        
  
        <div class="col-md-6" *ngIf="!checkPartnerRole">
          <div class="card cardStyle1">
            <div class="card-body align-items-start ml-4 mr-4">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-4"></div>
                <div class="col-md-4 cardHeader">2023 - 2024</div>
                <div class="col-md-4 cardHeader"> 2022 - 2023 </div>
              </div>
  
              <div class="row" style="text-align: center;background-color: #f2f2f2;">
                <div class="col-md-4 cardHeader">Man Days On Clients </div>
          
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ manDaysClientsCY || 0 }}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ manDaysClientsPY || 0 }}
                  </span>
                </div>
              </div>
  
              <div class="row mt-3 mb-3" style="text-align: center;background-color: #f2f2f2;">
                <div class="col-md-4 cardHeader">Man Days On PGB </div>
                
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ mandaysPgbCY || 0 }}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color: green;">
                    {{ mandaysPgbPY || 0 }}
                  </span>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div> -->
  
      
      <div class="row pt-2">
        <div class="col-md-12" [ngStyle]="{'height': showDashboard ? '485px' : '210px'}">
          <div class="card cardStyle3">
            <div class="card-body align-items-start">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-12 cardHeader headingFont" style=" background-color: white; color: #800000; ">Performance ({{CY}})</div>
              </div>
              <div class="col-md-12" style="overflow-y: auto; height: 420px;">
                <table class="table table-striped table-sm table-bordered mt-1">
                  <thead class="" style="top: 0; position: sticky;">
                    <tr>
                      <th *ngIf="showDashboard" scope="col" style="font-size: small;">Partner Name</th>
                      <th *ngIf="!showDashboard && userRole=='Partner'" scope="col" style="font-size: small;">Year</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Budgeted Fees</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Budgeted Cost</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Budgeted Contribution %</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Actual Reciept</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Actual Cost</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Actual Contribution %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of currentContributionsList; index as i" id="branch_{{ i + 1 }}">
                      <td *ngIf="showDashboard"><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td>
                      <td *ngIf="!showDashboard && userRole=='Partner'"><span class="card-content" style="font-size: small; color:#800000">{{data.year}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.fees|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.budgetedCost|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{getValidNumber(data.budgetedContributionPercentage) | number: '1.2-2' }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.actualFees|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000"> {{data.actualCost|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">
                          {{data.actualContributionPercentage| number: '2.'}}</span></td>
                    </tr>
                    <tr class="" style="bottom: 0; position: sticky;">
                      <td class="customDashbord" style="font-weight: bold;">Total</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalBudgetedFeesCy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalBudgetedCostCy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalBudgetedContributionPercentageCy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalActualFeesCy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalActualCostCy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalActualContributionPercentageCy|indianNumber}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
  
  
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-md-12" [ngStyle]="{'height': showDashboard ? '485px' : '210px'}">
          <div class="card cardStyle3">
            <div class="card-body align-items-start">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-12 cardHeader headingFont" style=" background-color: white; color: #800000; ">Performance ({{PY}})</div>
              </div>
              <div class="col-md-12" style="overflow-y: auto; height: 420px;">
                <table class="table table-striped table-sm table-bordered mt-1">
                  <thead class="" style="top: 0; position: sticky;">
                    <tr>
                      <th *ngIf="showDashboard" scope="col" style="font-size: small;">Partner Name</th>
                      <th *ngIf="!showDashboard && userRole=='Partner'" scope="col" style="font-size: small;">Year</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Budgeted Fees</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Budgeted Cost</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Budgeted Contribution %</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Actual Reciept</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Actual Cost</th>
                      <th scope="col" style="font-size: small; font-weight: normal;   ">Actual Contribution %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of previousContributionsList; index as i" id="branch_{{ i + 1 }}">
                      <td *ngIf="showDashboard"><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td>
                      <td *ngIf="!showDashboard && userRole=='Partner'"><span class="card-content" style="font-size: small; color:#800000">{{data.year}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.fees|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.budgetedCost|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{getValidNumber(data.budgetedContributionPercentage) | number: '1.2-2' }}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">{{data.actualFees|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000"> {{data.actualCost|indianNumber}}</span></td>
                      <td><span class="card-content" style="font-size: small; color:#800000">
                          {{data.actualContributionPercentage| number: '2.'}}</span></td>
                    </tr>
                    <tr class="" style="bottom: 0; position: sticky;">
                      <td class="customDashbord" style="font-weight: bold;">Total</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalBudgetedFeesPy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalBudgetedCostPy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalBudgetedContributionPercentagePy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalActualFeesPy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalActualCostPy|indianNumber}}</td>
                      <td class="customDashbord" style="font-size: normal;">{{totalActualContributionPercentagePy|indianNumber}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
  
  
  
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-2 mt-4">
        <div class="col-md-12">
          

          <!-- <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0"  >
              <div class="col-md-1"></div>
                <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                  Financial Data ( {{currentFinancialYear}} )
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-2 right-border customDashbord " >
                  Opening
                </div>
                <div class="col-md-2 right-border customDashbord " >
                  Bill Raised
                </div>
                <div class="col-md-2 right-border customDashbord " >
                  Receipt
                </div>
                <div class="col-md-2 right-border customDashbord " >
                  Closing
                </div>
                <div class="col-md-2 right-border customDashbord " >
                  Employee cost
                </div>
                <div class="col-md-2 right-border customDashbord " >
                  Contribution
                </div>
    
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.opening | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.billsRaised |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.receipt |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.closing |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.employeeCost |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.contribution |indianNumber  }}</span>
              </div>
              
            </div> 
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord" >
                %
              </div>
              <div class="col-md-2 right-border customDashbord" >
                >6 Months
              </div>
              <div class="col-md-2 right-border customDashbord" >
                Bad Debts
              </div>
              <div class="col-md-3 right-border customDashbord" >
                Credit Notes
              </div>
              <div class="col-md-3 right-border customDashbord" >
                Reimbursement
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.contributionPercent |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.billsGreaterSixMonths |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.badDebts |indianNumber  }}</span>
              </div>
              <div class="col-md-3 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.creditNotes |indianNumber  }}</span>
              </div>
              <div class="col-md-3 right-border">
                <span class="card-content" style="color:#800000">{{dashboardFinancials.reimbursement |indianNumber  }}</span>
              </div>
            </div>
          </div>   -->

          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0"  >
              <div class="col-md-1"></div>
                <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                  Financial Data ( {{currentYearMis.financialYear}} )
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-2 right-border customDashbord" >
                  Opening
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Bill Raised
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Receipt
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Closing
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Employee cost
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Contribution
                </div>
    
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.opening | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.billsRaised | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.receipt | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.closing | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.employeeCost | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.contribution | indianNumber}}</span>
              </div>
              
            </div> 
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord" >
                %
              </div>
              <div class="col-md-2 right-border customDashbord" >
                >6 Months
              </div>
              <div class="col-md-2 right-border customDashbord" >
                Bad Debts
              </div>
              <div class="col-md-3 right-border customDashbord" >
                Credit Notes
              </div>
              <div class="col-md-3 right-border customDashbord" >
                Reimbursement
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.contributionPercent | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.billsGreaterSixMonths | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.badDebts | indianNumber}}</span>
              </div>
              <div class="col-md-3 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.creditNotes | indianNumber}}</span>
              </div>
              <div class="col-md-3 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardFinancialsRest.reimbursement | indianNumber}}</span>
              </div>
            </div>
          </div>  
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0"  >
              <div class="col-md-1"></div>
                <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                  Financial Data ( {{previousYearMis.financialYear}} )
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-2 right-border customDashbord" >
                  Opening
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Bill Raised
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Receipt
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Closing
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Employee cost
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Contribution
                </div>
    
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.opening | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.billsRaised | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.receipt | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.closing | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.employeeCost | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.contribution | indianNumber}}</span>
              </div>
              
            </div> 
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border customDashbord" >
                %
              </div>
              <div class="col-md-2 right-border customDashbord" >
                >6 Months
              </div>
              <div class="col-md-2 right-border customDashbord" >
                Bad Debts
              </div>
              <div class="col-md-3 right-border customDashbord" >
                Credit Notes
              </div>
              <div class="col-md-3 right-border customDashbord" >
                Reimbursement
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.contributionPercent | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.billsGreaterSixMonths | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.badDebts | indianNumber}}</span>
              </div>
              <div class="col-md-3 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.creditNotes | indianNumber}}</span>
              </div>
              <div class="col-md-3 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardFinancialsRest.reimbursement | indianNumber}}</span>
              </div>
            </div>
          </div>  
        </div>
        

        <!-- <div class="col-md-12 " style="margin-top: 30px;">
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0">
              <div class="col-md-1"></div>
                <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                  Business Development
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-2 right-border customDashbord" >
                  New Clients
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  New Assignments
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Fee Rise
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Discontinued
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Net Addition
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Potential
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardBusiness.newClientsFees |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardBusiness.newAssignmentsFees |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardBusiness.feesRise |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardBusiness.discontinuedFees |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardBusiness.netAddition |indianNumber  }}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{dashboardBusiness.potentialClientsFees |indianNumber  }}</span>
              </div>
            </div> 
          </div>  
        </div>   -->

        <div class="col-md-12" style="margin-top: 30px;">
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0"  >
              <div class="col-md-1"></div>
                <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                  Business Development ( {{currentYearMis.financialYear}} )
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-2 right-border customDashbord" >
                  New Clients
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  New Assignments
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Fee Rise
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Discontinued
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Net Addition
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Potential
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.newClientsFees | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.newAssignmentsFees | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.feesRise | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.discontinuedFees | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.netAddition | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{currentYearMis.dashboardBusinessRest.potentialClientsFees | indianNumber}}</span>
              </div>
            </div> 
          </div>  
        </div>  
        <div class="col-md-12">
          <div class="card" style="text-align: center" >
            <div class="row col-md-12 m-0 p-0"  >
              <div class="col-md-1"></div>
                <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                  Business Development ( {{previousYearMis.financialYear}} )
                </div>
              <div class="row col-md-12 m-0 p-0 border">
                <div class="col-md-2 right-border customDashbord" >
                  New Clients
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  New Assignments
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Fee Rise
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Discontinued
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Net Addition
                </div>
                <div class="col-md-2 right-border customDashbord" >
                  Potential
                </div>
              </div>
            </div>
            <div class="row col-md-12 m-0 p-0 border">
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.newClientsFees | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.newAssignmentsFees | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.feesRise | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.discontinuedFees | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.netAddition | indianNumber}}</span>
              </div>
              <div class="col-md-2 right-border">
                <span class="card-content" style="color:#800000">{{previousYearMis.dashboardBusinessRest.potentialClientsFees | indianNumber}}</span>
              </div>
            </div> 
          </div>  
        </div> 
      </div>
      <div class="row pt-2  mt-4" >
        <div class="col-md-12">
          <div class="card cardStyle1">
            <div class="card-body align-items-start ">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-12 cardHeader headingFont" style="font-size: small; background-color: white; color: #800000; " >Head Count</div>
              </div>
              <div class="row customCardStylestyle"style="text-align: center; " >
                <div class="col cardHeader" style="font-size: small;">Particulars</div>
                <div class="col cardHeader" style="font-size: small;">Firm</div>
                <div class="col cardHeader" style="font-size: small;">Pune</div>
                <div class="col cardHeader" style="font-size: small;">Mumbai</div>
                <div class="col cardHeader" style="font-size: small;">Belgaum</div>
                <div class="col cardHeader" style="font-size: small;">Dharwad</div>
                <div class="col cardHeader" style="font-size: small;">Kolhapur</div>
              </div>
  
              <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    Employee
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Firm.employee}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Pune.employee}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Mumbai.employee}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Belgaum.employee}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Dharwad.employee}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Kolhapur.employee}}
                  </span>
                </div>
              </div>
              <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    Consultant
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Firm.consultant}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Pune.consultant}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Mumbai.consultant}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Belgaum.consultant}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Dharwad.consultant}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Kolhapur.consultant}}
                  </span>
                </div>
              </div>
              <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    Article
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Firm.article}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Pune.article}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Mumbai.article}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Belgaum.article}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Dharwad.article}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{headCountObj.Kolhapur.article}}
                  </span>
                </div>
              </div>
  
            </div>
          </div>
        </div>
      
      </div>
      <div class="row pt-2  mt-2" *ngIf="showDashboard ">
        <div class="col-md-12">
          <div class="card cardStyle1">
            <div class="card-body align-items-start ">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-12 cardHeader headingFont" style="font-size: small; background-color: white; color: #800000; " >Assets Count</div>
              </div>
              <div class="row customCardStylestyle" style="text-align: center;">
                <div class="col cardHeader" style="font-size: small;">Particulars</div>
                <div class="col cardHeader" style="font-size: small;">Firm</div>
                <div class="col cardHeader" style="font-size: small;">Pune</div>
                <div class="col cardHeader" style="font-size: small;">Mumbai</div>
                <div class="col cardHeader" style="font-size: small;">Belgaum</div>
                <div class="col cardHeader" style="font-size: small;">Dharwad</div>
                <div class="col cardHeader" style="font-size: small;">Kolhapur</div>
              </div>
  
              <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    Laptop
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Firm.laptops}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Pune.laptops}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Mumbai.laptops}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Belgaum.laptops}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Dharwad.laptops}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Kolhapur.laptops}}
                  </span>
                </div>
              </div>
              <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    Assigned
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Firm.assigned}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Pune.assigned}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Mumbai.assigned}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Belgaum.assigned}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Dharwad.assigned}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Kolhapur.assigned}}
                  </span>
                </div>
              </div>
              <div class="row mt-3 mb-3" style="text-align: center; background-color: #f2f2f2;">
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    Instock
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Firm.instock}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Pune.instock}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Mumbai.instock}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Belgaum.instock}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Dharwad.instock}}
                  </span>
                </div>
                <div class="col">
                  <span class="card-content" style="text-align: center; font-size: small; color:#800000">
                    {{assetCountObj.Kolhapur.instock}}
                  </span>
                </div>
              </div>
  
            </div>
          </div>
        </div>
      
      </div>
      <!-- <div class="row pt-2  mt-2" *ngIf="showDashboard || userRole=='Partner'">
        <div class="col-md-12" [ngStyle]="{'height': showDashboard ? '495px' : '200px'}">
          <div class="card cardStyle3">
            <div class="card-body align-items-start">
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-12 cardHeader" style="background-color: white; color: #800000;" >Partner Assignment and Mandays</div>
              </div>
              <div class="col-md-12" style="    overflow-y: auto; height: 420px;">
               
                <table style="  width: 100%;
                  overflow-x: scroll;" class="table table-striped table-sm table-bordered mt-1">
                  <thead class="" style="top: 0; position: sticky;">
                    <tr >
                      <th *ngIf="showDashboard " rowspan="2" style="vertical-align: inherit; text-align: center; font-size: small;"  scope="col">Partner Name</th>
                      <th colspan="4" style="text-align: center; font-size: small;"
                        *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                        {{item.year}}</th>
                     
                    </tr>
                    <tr>
  
                      <ng-container
                        *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                        <th style="font-size: small;">
                          Clients
                        </th>
                        <th style="font-size: small;">
                          Assignments
                        </th>
                        <th style="font-size: small;">
                          Client Mandays
                        </th>
                        <th style="font-size: small;">
                          PGB Mandays
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of partnerAssignmentAndMandaysList; index as i" id="branch_{{ i + 1 }}">
                      <td *ngIf="showDashboard "><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td>
                      <ng-container *ngFor="let item of data.assignmentAndMandaysDtos; index as i">
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.totalClients}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.totalAssignments}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.mandaysClients}}</span></td>
                        <td><span class="card-content" style="font-size: small; color:#800000">{{item.mandaysPGB}}</span>
                        </td>
                      </ng-container>
                      
                    </tr>
  
                  </tbody>
                </table>
             
  
  
              </div>
  
  
  
            </div>
          </div>
          
        </div>
      </div> -->
      <div class="row mt-3 mb-2" *ngIf="showDashboard || userRole=='Partner'">
      <div class="col-md-12" >
        <div class="card" style="text-align: center" >
          <div class="row col-md-12 m-0 p-0">
            <div class="col-md-1"></div>
              <div class="col-md-9 cardHeader headingFont" style="background-color: white; color: #800000;">&nbsp;
                Partner Assignment and Mandays
              </div>
            <div class="row col-md-12 m-0 p-0">
              <div class="row col-md-12" style="overflow-y: auto; height: 420px;">
               
                <table style="  width: 100%;
                  overflow-x: scroll;" class="table table-striped table-sm table-bordered mt-1">
                  <thead class="" style="top: 0; position: sticky;">
                    <tr >
                      <th *ngIf="showDashboard " rowspan="2" style="vertical-align: inherit; text-align: center; font-size: small; font-weight: normal;"  scope="col">Partner Name</th>
                      <th colspan="4" style="text-align: center; font-size: small; font-weight: normal; "
                        *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                        {{item.year}}</th>
                     
                    </tr>
                    <tr>
  
                      <ng-container
                        *ngFor="let item of partnerAssignmentAndMandaysList[0].assignmentAndMandaysDtos; index as i">
                        <th style="font-size: small; font-weight: normal; ">
                          Clients
                        </th>
                        <th style="font-size: small; font-weight: normal; ">
                          Assignments
                        </th>
                        <th style="font-size: small; font-weight: normal; ">
                          Client Mandays
                        </th>
                        <th style="font-size: small; font-weight: normal; ">
                          PGB Mandays
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of partnerAssignmentAndMandaysList; index as i" id="branch_{{ i + 1 }}">
                      <td *ngIf="showDashboard "><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td>
                      <ng-container *ngFor="let item of data.assignmentAndMandaysDtos; index as i">
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.totalClients}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.totalAssignments}}</span></td>
                        <td><span class="card-content"
                            style="font-size: small; color:#800000">{{item.mandaysClients}}</span></td>
                        <td><span class="card-content" style="font-size: small; color:#800000">{{item.mandaysPGB}}</span>
                        </td>
                      </ng-container>
                      
                    </tr>
  
                  </tbody>
                </table>
             
  
  
              </div>
            </div>
          </div>
        </div>  
      </div>  
      </div>
      <!-- Training Hours Balance  -->
      <!-- <div class="row pt-2" *ngIf="!showDashboard && userRole=='Partner'">
        <div class="col-md-6" >
          <div class="card cardStyle1">
            
            <div class="card-body align-items-start ml-4 mr-4">
              <div class="row">
                <div class="col-md-1"><i class="fa fa-user-times" style="color:#800000"></i></div>
                <div class="col-md-9 cardHeader">&nbsp;
                 Training Hours(Balance)
                </div>
              </div>
              <hr/>
              <div class="row pb-2" style="text-align: center;">
                <div class="col-md-4 cardHeader">PGB as presenter</div>
                <div class="col-md-4 cardHeader">PGB Internal</div>
                <div class="col-md-4 cardHeader">CPE</div>
              </div>
  
              <div class="row" style="text-align: center;background-color: #f2f2f2;">
                <div class="col-md-4">
                  <span class="card-content" style="color:#800000">
                    {{ balanceTraining.pgbPresenter || 0 }}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color:#800000">
                    {{ balanceTraining.pgbInternal || 0 }}
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="card-content" style="color:#800000">
                    {{ balanceTraining.cpe || 0 }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
 
   
    <div class="row pt-2 mt-4">
      <div class="col-md-6" style="height : '355px'">
        <div class="card cardStyle3">
          <div class="card-body align-items-start">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader headingFont" style=" background-color: white; color: #800000;  ">Penalty</div>
            </div>
            <div class="col-md-12" style="overflow-y: auto; height: 292px;">
              <table class="table table-striped table-sm table-bordered mt-1">
                <thead class="" style="top: 0; position: sticky;">
                  <tr>
                    <th scope="col" style="font-size: small; font-weight: normal;">Partner Name</th>
                    <th scope="col" style="font-size: small; font-weight: normal;">Charged</th>
                    <th scope="col" style="font-size: small; font-weight: normal;">Uncharged</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of partnersPenaltyList; index as i" id="branch_{{ i + 1 }}">
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.charged | indianNumber }}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.unCharged | indianNumber}}</span></td>
                  </tr>

                </tbody>
              </table>
            </div>



          </div>
        </div>
      </div>
      <div class="col-md-6" style="height : '355px'">
        <div class="card cardStyle3">
          <div class="card-body align-items-start">
            <div class="row pb-2" style="text-align: center;">
              <div class="col-md-12 cardHeader headingFont" style=" background-color: white; color: #800000; ">Independance</div>
            </div>
            <div class="col-md-12" style="overflow-y: auto; height: 292px;">
              <table class="table table-striped table-sm table-bordered mt-1">
                <thead class="" style="top: 0; position: sticky;">
                  <tr>
                    <th scope="col" style="font-size: small; font-weight: normal;  ">Partner Name</th>
                    <th scope="col" style="font-size: small; font-weight: normal;  ">No Confirmation</th>
                    <th scope="col" style="font-size: small; font-weight: normal;  ">Delay</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of partnersPendingDeclarationList; index as i" id="branch_{{ i + 1 }}">
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.name}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.declarationsCount | indianNumber}}</span></td>
                    <td><span class="card-content" style="font-size: small; color:#800000">{{data.delayInDays | indianNumber}}</span></td>
                  </tr>

                </tbody>
              </table>
            </div>



          </div>
        </div>
      </div>
    </div>
  
  </div>
  